<template>
  <div>
<h2 class="goth">Presens av svaga verb</h2>

        <p class="grammatikparagrafbredd leftorient">I den moderna svenskan böjs inte verben olika (konjugeras) beroende på vem som
            utför handlingen eller hur många de är. Vi säger:</p><br>

            <p class="grammatikparagrafbredd leftorient"><i>jag stå<b>r</b> <br> du stå<b>r</b> <br> han stå<b>r</b> <br> vi stå<b>r</b></i> &nbsp; &nbsp; &nbsp; &nbsp; o.s.v.</p><br>
            <p class="grammatikparagrafbredd leftorient"> På så vis skiljer sig den moderna svenskan från många andra europeiska språk;
            t.ex. engelskan:</p><br>
             <p class="grammatikparagrafbredd leftorient"><i>I stand<br> you stand<br>he stand<b>s</b></i>&nbsp; &nbsp; &nbsp; &nbsp; o.s.v.,</p>

<br>

                      <p class="grammatikparagrafbredd leftorient">
                          På tyskan böjs verben på många olika sätt beroende på person (1:a, 2:a, 3:e) och
                          numerus (singular/plural) hos den som utför handlingen.
                          I regel används någon av ändelserna <b>-e, -st, -t </b>eller<b> -en </b>på verbets
                          stam enligt följande mönster:</p>

<br><p class="grammatikparagrafbredd leftorient">Exempel med verbet <i>stehen</i></p>



    <table class="">
<br>

        <tr class="leftorient">
            <td class="ljusgra"><i>ich</i></td>
            <td class="ljusgra"><i>steh<b>e</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="ljusgra"><i>du</i></td>
            <td class="ljusgra"><i>steh<b>st</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="ljusgra"><i>er<br> es<br> sie</i></td>
            <td class="ljusgra"><i>steh<b>t</b></i></td>
        </tr>

        <tr class="leftorient">

        </tr>


        <tr class="leftorient">
            <td class="upperspace ljusgra"><i>wir</i></td>
            <td class="ljusgra"><i>steh<b>en</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="ljusgra"><i>ihr</i></td>
            <td class="ljusgra"><i>steh<b>t</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="ljusgra"><i>sie<br> Sie</i></td>
            <td class="ljusgra"><i>steh<b>en</b></i></td>
        </tr>


    </table>




<br>

          <br>
          <p class="grammatikparagrafbredd leftorient">Exempel med verbet <i>spielen</i></p>


    <table class="nej-linjer">
<br>

        <tr class="leftorient">
            <td class="ljusgra"><i>ich</i></td>
            <td class="ljusgra"><i>spiel<b>e</b></i></td>
        </tr>

        <tr class="leftorient">

            <td class="ljusgra"><i>du</i></td>
            <td class="ljusgra"><i>spiel<b>st</b></i></td>
        </tr>



        <tr class="leftorient">

            <td class="ljusgra"><i>er<br> es<br> sie</i></td>
            <td class="ljusgra"><i>spiel<b>t</b></i></td>
        </tr>

        <tr class="leftorient">

        </tr>


        <tr class="leftorient">
            <td class="upperspace ljusgra"><i>wir</i></td>
            <td class="ljusgra"><i>spiel<b>en</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="ljusgra"><i>ihr</i></td>
            <td class="ljusgra"><i>spiel<b>t</b></i></td>
        </tr>

        <tr class="leftorient">


            <td class="ljusgra"><i>sie<br> Sie</i></td>
            <td class="ljusgra"><i>spiel<b>en</b></i></td>
        </tr>


    </table>

<br><br><br>
    <br><br><p class="grammatikparagrafbredd leftorient">I bland kan ett <b>-e-</b> skjutas in mellan stammen och ändelsen om
        stammen slutar på en sådan konsonant, som gör att ordet annars skulle bli
        svårt att uttala.</p>
        <br>
    <p class="grammatikparagrafbredd leftorient">Ett exempel på ett sådant ord är <i>baden</i></p>
    <br>



<table class="nej-linjer">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i>ich</i></td>
        <td class="ljusgra"><i>bad<b>e</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>du</i></td>
        <td class="ljusgra"><i>bad<b><div class="accented">e</div>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>er<br> es<br> sie</i></td>
        <td class="ljusgra"><i>bad<b><div class="accented">e</div>t</b></i></td>
    </tr>


    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace ljusgra"><i>wir</i></td>
        <td class="ljusgra"><i>bad<b>en</b></i></td>
    </tr>



    <tr class="leftorient">


        <td class="ljusgra"><i>ihr</i></td>
        <td class="ljusgra"><i>bad<b><div class="accented">e</div>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>sie<br> Sie</i></td>
        <td class="ljusgra"><i>bad<b>en</b></i></td>
    </tr>


</table>




<br>
<br><div class="quasi-p grammatikparagrafbredd leftorient"><div class="mindre">För mindre än 100 år sedan böjdes
    verben på liknande sätt även i svenskan, t.ex. barnvisan om blåsippor:
Första versen <i>Blåsipp<b>an</b> ute i backarna <b>står</b>, niger och säger att nu är det vår...</i>,
men andra versen <i>...blåsipp<b>or</b> ute i backarna <b>stå</b>, ha varken skor eller strumpor på.</i> </div></div>


<br><br><br><br>

</div>

</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "presens svaga verb"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}
</style>
